<template>
  <div class="VideoListCard">
    <template v-if="videolist == []">
      <div class="null">
        <img src="@/common/images/leveing/video/null.png" alt="直播空">
        <p>暂无内容</p>
      </div>
    </template>
    <template v-else>
      <div class="video-item" v-for="(item, index) in videolist" :key="index" @click="startPopu(item.fileurl, item.coveratturl)">
        <img class="video-img" v-lazy="item.coveratturl" :alt="item.name">
        <img class="play" src="@/common/images/leveing/video/play.png" alt="播放">
      </div>
    </template>
      <VideoPlayDialog ref="videopopu"></VideoPlayDialog>
  </div>
  <!-- end 视频集合模块 -->
</template>

<script>
import VideoPlayDialog from './VideoPlayDialog.vue'
export default {
  name: 'VideoListCard',
  props: ['item'],
  data () {
    return {
      videolist: []
    }
  },
  mounted () {
    this.videolist = this.item.videolist
  },
  methods: {
      startPopu(fileurl, coveratturl) { // 开启弹窗
        this.videopopu = this.$refs.videopopu.startVideoPlayPopu(fileurl, coveratturl)
      }
  },
  filters: {},
  watch: {},
  computed: {},
  components: {
      VideoPlayDialog
  }
}
</script>

<style lang="scss" type="text/scss" scoped>
.VideoListCard {
    overflow: hidden;
    margin-left: -26px;

    .null {
      margin-top: 40px;
      img {
        display: block;
        margin: auto;
        margin-top: 30px;
        width: 127px;
        height: 120px;
      }
      p {
        margin-top: 10px;
        font-size: 14px;
        text-align: center;
        color: #999;
      }
    }

    .video-item {
        float: left;
        margin-bottom: 27px;
        margin-left: 26px;
        position: relative;
        width:256px;
        height:143px;
        cursor: pointer;

        .video-img {
            width: 100%;
            height: 100%;
            border-radius: 8px;
            background: #ccc;
        }
        .play {
            position: absolute;
            margin: auto;
            left: 0;
            right: 0;
            top: 0;
            bottom: 0;
            width:50px;
            height:50px;
        }
    }

}
</style>